module.exports = __webpack_public_path__ + "img/specials-multislider-6040--default.da29124c.jpg";